import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { OnyxEvent } from '../models/event';
import { EventHttpService } from './event.http.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { BulkUploadResponse } from '../models/bulk-upload-response';

@Injectable()
export class EventStore {

  private mySelectedEvent: BehaviorSubject<OnyxEvent> = new BehaviorSubject(null);

  constructor(private eventHttpService: EventHttpService,
              private flashMessagesService: FlashMessagesService) {
  }

  /**
   * Returns an observable containing the current event.
   * Used in any case when data needs to be shown on a screen.
   *
   * @returns {Observable<T>}
   */
  get selectedEvent(): Observable<OnyxEvent> {
    return this.mySelectedEvent.asObservable();
  }

  /**
   * Retrieves event.  This method returns an observable
   * and should be used only in route resolvers.
   *
   * @param eventId
   * @returns {Observable<OnyxEvent>}
   */
  getEvent(eventId: number): Observable<OnyxEvent> {
    return this.eventHttpService.get(eventId)
      .catch((error: any) => {
        // Catch error here so resolver also displays error.
        this.flashMessagesService.error('MESSAGES.ERROR.GET_EVENT', `Error retrieving OnyxEvent: ${error}`);
        return Observable.throw(error);
      })
      .map((res: OnyxEvent) => {
        this.mySelectedEvent.next(res);
        return res;
      });
  }

  addEvent(newRec: OnyxEvent): Observable<OnyxEvent> {
    return this.eventHttpService.add(newRec)
      .map((res: OnyxEvent) => {
        this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
        this.mySelectedEvent.next(res);
        return res;
      });
  }

  updateEvent(newRec: OnyxEvent): Observable<OnyxEvent> {
    return this.eventHttpService.update(newRec)
      .map((res: OnyxEvent) => {
        this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
        this.mySelectedEvent.next(res);
        return res;
      });
  }

  downloadInvalidEventsCsv(fileId: number): Observable<any> {
    return this.eventHttpService.downloadInvalidEventsCsv(fileId);
  }

  deleteEvent(eventId: number): Observable<OnyxEvent> {
    return this.eventHttpService.delete(eventId)
      .catch((error => {
        this.flashMessagesService.error('MESSAGES.ERROR.DELETE_EVENT');
        return Observable.throw(error);
      }))
      .map((res: OnyxEvent) => {
        this.flashMessagesService.success('MESSAGES.SUCCESS.DELETE_EVENT');
        this.mySelectedEvent.next(null);
        return res;
      });
  }

  importEventsViaCsv(file: File): Observable<BulkUploadResponse> {
    return this.eventHttpService.importEventsViaCsv(file)
      .catch((error => {
        return Observable.throw(error);
      }))
      .map((importResponse: BulkUploadResponse) => {
        return importResponse;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event.store.ts